import { AdminTaskStatus } from '@/client/admin-tasks';
import { TranslationFunctionType } from '@/common/types/locales.type';
import { MenuItem } from 'primereact/menuitem';
import { TabMenu } from 'primereact/tabmenu';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface TaskTabsProps {
  activeTab: AdminTaskStatus;
  onTabChange: (tab: AdminTaskStatus) => void;
  id?: string;
}

interface TabItem {
  key: AdminTaskStatus;
  label: string;
}

const getTabItems = (t: TranslationFunctionType): TabItem[] => [
  {
    key: AdminTaskStatus.TODO,
    label: t('admin.tasks.tabs.active'),
  },
  {
    key: AdminTaskStatus.COMPLETED,
    label: t('admin.tasks.tabs.completed'),
  },
  {
    key: AdminTaskStatus.SKIPPED,
    label: t('admin.tasks.tabs.skipped'),
  },
];

export const TaskTabs: React.FC<TaskTabsProps> = ({
  activeTab,
  onTabChange,
  id,
}) => {
  const { t } = useTranslation();
  const tabItems = getTabItems(t);

  const menuItems: MenuItem[] = tabItems.map((item) => ({
    label: item.label,
  }));

  const activeIndex = tabItems.findIndex((item) => item.key === activeTab);

  const handleTabChange = (e: { index: number }) => {
    const selectedTab = tabItems[e.index];
    if (selectedTab) {
      onTabChange(selectedTab.key);
    }
  };

  return (
    <TabMenu
      id={id}
      model={menuItems}
      activeIndex={activeIndex}
      onTabChange={handleTabChange}
      className="mb-0 mt-4"
    />
  );
};
